/** Ubezpieczenia — złożenie słowników obszarów pod `ins.*` (plik FUNDAMENTU; obszary edytują tylko swój `ins-<obszar>.ts`). */
import { insAnalyticsEn, insAnalyticsPl } from './ins-analytics';
import { insClaimsEn, insClaimsPl } from './ins-claims';
import { insCommonEn, insCommonPl, insEnumsEn, insEnumsPl, insErrorsEn, insErrorsPl } from './ins-common';
import { insPoliciesEn, insPoliciesPl } from './ins-policies';
import { insTendersEn, insTendersPl } from './ins-tenders';

export const insPl = {
  common: insCommonPl,
  enums: insEnumsPl,
  errors: insErrorsPl,
  policies: insPoliciesPl,
  claims: insClaimsPl,
  tenders: insTendersPl,
  analytics: insAnalyticsPl,
};

export const insEn = {
  common: insCommonEn,
  enums: insEnumsEn,
  errors: insErrorsEn,
  policies: insPoliciesEn,
  claims: insClaimsEn,
  tenders: insTendersEn,
  analytics: insAnalyticsEn,
};
